import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';

export const fileKey = ['figures'];

const useFigures = () => useQuery({
  queryKey: fileKey,
  queryFn: () => agent.getClient().get('file-data/static?tag=figures', {
    responseType: 'arraybuffer',
  }).then(
    (response) => response.data,
  ),
});

export default useFigures;
